import * as v from "react";
import { i as p, b as c, E as d, x as o, a as h, r as m, c as f } from "../createReactComponent-58f9bea8.mjs";
import { n as x } from "../property-9daa16cd.mjs";
import { e as n } from "../class-map-2994e95e.mjs";
import { r as b } from "../button-7600b6ca.mjs";
import { r as g } from "../icon-c572aa57.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
var u = Object.defineProperty;
class l extends d {
  constructor() {
    super(...arguments), this.level = 1;
  }
  goTo(e) {
    e < 1 || e > 3 || e === this.level || (this.level = e, this.dispatchCustomEvent("level-change", { level: this.level }));
  }
  next() {
    this.goTo(this.level + 1);
  }
  previous() {
    this.goTo(this.level - 1);
  }
  getHeader() {
    return this.level === 1 ? o`
        <div class="panel-controls--header">
          <slot name="header-1"></slot>
        </div>
      ` : this.level === 2 ? o`
        <div class="panel-controls--header">
          <slot name="header-2">
            <ex-button
              flavor="branded"
              type="tertiary"
              size="small"
              class="back-button"
              buttontype="button"
              @click=${() => this.previous()}
            >
              <ex-icon icon="Left caret" slot="prefix"></ex-icon>
              Back
            </ex-button>
            <div class="separator"></div>
          </slot>
        </div>
      ` : this.level === 3 ? o`
        <div class="panel-controls--header">
          <slot name="header-3">
            <ex-button
              flavor="branded"
              type="tertiary"
              size="small"
              class="back-button"
              buttontype="button"
              @click=${() => this.previous()}
            >
              <ex-icon icon="Left caret" slot="prefix"></ex-icon>
              Back
            </ex-button>
            <div class="separator"></div>
          </slot>
        </div>
      ` : h;
  }
  getTransformStyle() {
    return `transform: translateX(${-100 * (this.level - 1)}%);`;
  }
  getSlotClass(e) {
    return n({ "panel-slot": !0, "not-in-view": this.level !== e });
  }
  render() {
    return o`
      <div
        class="${n({ panel: !0 })}"
      >
        ${this.getHeader()}
        <div class="panel-viewport">
          <div class="panel-content" style=${this.getTransformStyle()}>
            <div class=${this.getSlotClass(1)}>
              <slot name="level-1"></slot>
            </div>
            <div class=${this.getSlotClass(2)}>
              <slot name="level-2"></slot>
            </div>
            <div class=${this.getSlotClass(3)}>
              <slot name="level-3"></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
l.styles = p`
    ${c(`:host *,:host *:before,:host *:after{box-sizing:border-box}:host .panel{display:flex;flex-direction:column;position:relative;height:100%}:host .not-in-view{opacity:.5;pointer-events:none}:host .panel-viewport{overflow:hidden;width:100%;position:relative;height:100%;flex-grow:1}:host .panel-content{display:flex;align-items:flex-start;height:100%;transition:transform .2s cubic-bezier(.4,0,.2,1)}:host .panel-slot{width:100%;height:100%;flex-shrink:0;overflow:auto;display:block}:host .panel-controls--header{display:flex;flex-direction:column;align-items:flex-start;gap:8px;margin-bottom:2px}:host .back-button{width:auto!important;align-self:flex-start}:host .separator{width:100%;border:.5px solid var(--exo-color-border-secondary)}
`)}
  `, ((t, e, a, w) => {
  for (var r, s = void 0, i = t.length - 1; i >= 0; i--)
    (r = t[i]) && (s = r(e, a, s) || s);
  s && u(e, a, s);
})([x({ type: Number, reflect: !0 })], l.prototype, "level");
const y = (t = "") => {
  m("ex-panel", l, t), b(t), g(t);
}, P = f({ tagName: "ex-panel", elementClass: l, react: v, events: { onLevelChange: "level-change" }, displayName: "ExPanel", registerWebComponent: y });
export {
  P as ExPanel,
  y as register
};
